module.exports = __webpack_public_path__ + "img/m-banner-3m.d150e720.png";